import React, { Component } from 'react';
import { getUser} from '../Actions/UserActions';

import { connect } from 'react-redux';

import NavBar2 from "./NavBar2";
import SiteFoot from "../Components/SiteFoot";

class chinapractice extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            width: window.innerWidth,
            password: '',
            error: ''
        };
    }
    componentWillMount() {
        window.addEventListener('resize', this.handleWindowSizeChange);
    }

// make sure to remove the listener
// when the component is not mounted anymore
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
    }
    handleWindowSizeChange = () => {
        this.setState({ width: window.innerWidth });
    };











    render() {

        var lang
        if(this.props.lang==="zh"||this.props.lang==="zh-hk"||this.props.lang==="zh-cn"||this.props.lang==="zh-sg"||this.props.lang==="zh-tw"|| this.props.lang==="zh-HK"||this.props.lang==="zh-CN"||this.props.lang==="zh-SG"||this.props.lang==="zh-TW"){
            lang= "zh"
        }else{
            lang="en"
        }



        return (
            <div style={{ height: "100%",}}>



            <div  style={{backgroundColor:"white", width: "100%", display: "flex", top: "0", position:"fixed", left: "0px",
                zIndex: "500",  borderStyle: "solid",  borderColor: "FireBrick", borderWidth: "0px 0px 2px 0px"}}>


                <NavBar2/>












            </div>
            {this.state.width<500 &&<div style={{height: "16vw",}} ></div>}
            {this.state.width>=500 &&<div style={{height: "10vw", }} ></div>}

            {lang==="en" &&  <div>
                <div style={{width: "90%", margin: "auto", display: "block", padding: "0px", fontFamily:"Open Sans, sans-serif"}} >
                    <div style={{width: "50%", maxWidth:"50%", verticalAlign:"top",  minWidth:"20em",display: "inline-block", backgroundColor:"white", padding: "30px",}} >

                        <span style={{fontSize: "1.5em", fontWeight: "bold"}}>China Practice</span><p/>
                        <span style={{fontSize: ".8em"}}>The Morrow Firm is one of the very few boutique law firms in the United States that offer top-notch, bilingual legal services on China-related matters. Our founding attorney Xinlin Morrow is a native Mandarin speaker.</span><p/>

                        <span style={{fontSize: ".8em"}}>Representative experience:</span><p/>
                        ​

                        <ul><span style={{fontSize: ".8em"}}><li>Served as trial counsel for T-Mobile in a three-week jury trial in Seattle, winning verdicts on misappropriation of trade secrets and breach of contract claims against Huawei Devices USA. See <a href="https://www.seattletimes.com/business/technology/july-awards-t-mobile-48m-in-trade-secrets-case-against-huawei/" target="_blank" rel="noopener noreferrer"> Seattle Times</a>, Jury awards T-Mobile $4.8M in trade-secrets case against Huawei; <a href="https://www.nytimes.com/2014/09/06/business/t-mobile-accuses-huawei-of-theft-from-laboratory.html" target="_blank" rel="noopener noreferrer"> New York Times</a>, T-Mobile Accuses Huawei of Theft From Laboratory.</li></span><br/>
                        <span style={{fontSize: ".8em"}}><li>Representing a prominent Chinese businesswoman in an $11 million breach of contract and fraud case.​</li></span><br/>
                        <span style={{fontSize: ".8em"}}><li>Represented an American medical device company in a patent infringement and antitrust case against a Chinese medical device company.</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>Represented a Chinese businessman accused of trade secrets theft.</li></span><br/>
                        <span style={{fontSize: ".8em"}}><li>Represented an individual in a federal criminal investigation related to illegal importation from China, money laundering, and tax fraud.</li></span><br/>
                        <span style={{fontSize: ".8em"}}><li>Represented a prominent Chinese businessman facing insider trading charges in parallel civil and criminal proceedings.</li></span><br/>
                        <span style={{fontSize: ".8em"}}><li>Represented a Fortune 500 executive facing allegations of Foreign Corrupt Practice Act (FCPA) violations in China.</li></span><br/></ul>
                    </div>
                    <div style={{width: "49%", maxWidth:"50%",  height:"100%", minWidth:"20em",verticalAlign:"top", display: "inline-block",  padding: "5px", top:"0px", }} ><img alt="China Practice"   style={{top:"0px", width: "100%"}} src="https://firebasestorage.googleapis.com/v0/b/absite-15edf.appspot.com/o/chinapractice.jpg?alt=media&token=37c24e0c-f826-4880-a67c-f225acca7d17"/>

                    </div>
                </div>
            </div>}
            {lang==="zh" &&  <div>
                <div style={{width: "90%", margin: "auto", display: "block", padding: "0px", fontFamily:"Open Sans, sans-serif"}} >
                    <div style={{width: "50%", maxWidth:"50%", verticalAlign:"top",  minWidth:"20em",display: "inline-block", backgroundColor:"white", padding: "30px",}} >

                        <span style={{fontSize: "1.5em", fontWeight: "bold"}}>中国业务</span><p/>
                        <span style={{fontSize: ".8em"}}>沫若律师事务所是美国为数不多的为中国相关业务提供一流双语法律服务的精品律师事务所之一。主任律师李馨霖能流利地使用中文。</span><p/>

                        <span style={{fontSize: ".8em"}}>代表经验：</span><p/>
                        ​

                        <ul><span style={{fontSize: ".8em"}}><li>在西雅图进行为期三周的陪审团审判中担任T-Mobile的审判律师，赢得了对华为美国终端公司盗用商业机密和违反合同索赔的判决。参见<a href="https://www.seattletimes.com/business/technology/july-awards-t-mobile-48m-in-trade-secrets-case-against-huawei/" target="_blank" rel="noopener noreferrer">西雅图时报报道</a>，Jury awards T-Mobile $4.8M in trade-secrets case against Huawei；<a href="https://www.nytimes.com/2014/09/06/business/t-mobile-accuses-huawei-of-theft-from-laboratory.html" target="_blank" rel="noopener noreferrer">纽约时报报道</a>，T-Mobile Accuses Huawei of Theft From Laboratory。</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>代表一位成功的中国女商人处理1100万美元的合同违约和欺诈案件。​</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>代表一家美国医疗器械公司处理针对中国医疗器械公司的专利侵权和反垄断诉讼。</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>代表受到窃取商业秘密指控的中国商人。</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>代表个人客户处理涉及从中国非法进口，洗钱和税务欺诈的联邦刑事调查。</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>代表一位中国企业高管在民事和刑事诉讼中面临内幕交易指控进行辩护。</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>代表一位财富500强的高管面临在中国违反“反海外腐败法”（FCPA）的指控进行辩护。</li></span><br/></ul>
                    </div>
                    <div style={{width: "49%", maxWidth:"50%",  height:"100%", minWidth:"20em",verticalAlign:"top", display: "inline-block",  padding: "5px", top:"0px", }} ><img  alt="中国业务" style={{top:"0px", width: "100%"}} src="https://firebasestorage.googleapis.com/v0/b/absite-15edf.appspot.com/o/chinapractice.jpg?alt=media&token=37c24e0c-f826-4880-a67c-f225acca7d17"/>

                    </div>
                </div>
            </div>}


            <SiteFoot lang={lang}/>
            </div>


        );
    }
}

function mapStateToProps(state, ownProps) {
    return { user: state.user, admin: state.admin, lang: state.lang };
}

export default connect(mapStateToProps, { getUser })(chinapractice);



// WEBPACK FOOTER //
// ./src/Containers/chinapractice.js